/*
 *
 * Date: 2025
 * Description: Sub part component for price
 * Author: Philippe Leroux @SKITSC
 *
 */

//Module
import { ReactElement } from "react"
import { Tooltip , Box , Typography } from "@mui/material"

//Utils
import { formatTimestamp } from "../../utils/utility"


export interface i_sub_part_props {
    price : string
    stock : string | undefined
    time : number | undefined
    type : 'Avatar' | 'Tiger' | 'Lkq' | 'Atpac' | 'Rockauto' | 'Moneydex'
}
const SubPart = ( { price , stock  , time , type } : i_sub_part_props )  : ReactElement => {
    const formatPrice = ( price : string ) => {
        const cleanCurrency = (input: string): string =>{
            return input.replace(/[^0-9.,]/g, '');
        }
        return cleanCurrency(price) + '$' 
    }
    const pTitle = { fontSize : 14 , fontWeight : 700}
    return (
        <Tooltip title={time !== undefined? formatTimestamp(Math.round(time)) : 'No date'}>
            <Box sx={{ display : 'flex'}}>
                <Box sx={pTitle}>{type + ' '} price: <Typography sx={{ display : 'inline' , fontSize : 12 , textDecoration : 'underline' , fontWeight : 800}}>{formatPrice(price)}</Typography></Box>
                <Typography sx={{ marginLeft : 2 , fontSize : 12}}>{stock ? stock : 'N/A'}</Typography>
            </Box>
        </Tooltip>
    )
}

export default SubPart